import { useSuspenseQuery } from '@tanstack/react-query';
import { fetchFilterCustomFields } from 'api/filters';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { filterQueryKeys } from 'queries/filter-query-keys';

const useCustomFieldFilterItems = () => {
    const { accountId } = useCurrentAccount();

    return useSuspenseQuery({
        queryKey: filterQueryKeys.customFields(accountId, 'contact'),
        queryFn: () => fetchFilterCustomFields({ accountId, scope: 'contact' }),
        staleTime: Infinity,
    });
};

export { useCustomFieldFilterItems };
